import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'customers-actions',
  storeModule.createStoreModule('customers-actions', {
    fetchSingleURL: ({ id }) => `customers/${id}/actions`
  })
)
